import { supabase } from '../../lib/supabase';
import type { Saved } from '../../store/game';
import { maybeVerifyLive } from '../leaderboard/live';
import { liveSummary } from '../../engine/score';

let timer: ReturnType<typeof setTimeout> | null = null;
let claimOk = true;
/** Kennzahlen für die Live-Liste (ungeprüft, der Server prüft nach). */
function claimOf(state: any) { try { return state && !state.mp ? liveSummary(state) : null; } catch { return null; } }
/** Cloud-Speicherstand, entprellt: höchstens alle 3 Sekunden ein Schreibzugriff. */
export function cloudSaveDebounced(saved: Saved) {
  if (!supabase) return;
  if (timer) clearTimeout(timer);
  timer = setTimeout(async () => {
    const { data: u } = await supabase!.auth.getUser(); if (!u.user) return;
    const row: Record<string, unknown> = { user_id: u.user.id, slot: 1, state: saved.state, journal: saved.journal, updated_at: new Date().toISOString() };
    // Live-Liste: Kennzahlen aus dem Browser (Migration 0009). Fehlt die Spalte noch, ohne sie speichern.
    if (claimOk) row.live_claim = claimOf(saved.state);
    let { error } = await supabase!.from('saves').upsert(row, { onConflict: 'user_id,slot' });
    if (error && claimOk && /live_claim/.test(error.message)) { claimOk = false; delete row.live_claim; ({ error } = await supabase!.from('saves').upsert(row, { onConflict: 'user_id,slot' })); }
    if (!error) maybeVerifyLive(saved.state); // Live-Liste der Bestenliste
  }, 3000);
}
export async function cloudLoad(): Promise<Saved | null> {
  if (!supabase) return null;
  const { data: u } = await supabase.auth.getUser(); if (!u.user) return null;
  const { data } = await supabase.from('saves').select('state,journal,updated_at').eq('user_id', u.user.id).eq('slot', 1).maybeSingle();
  return data?.state ? { state: data.state, journal: Array.isArray(data.journal) ? data.journal : [] } : null;
}
